module.exports = __webpack_public_path__ + "img/1080_10.f9435ce9.jpg";